import { AboutContent, AboutImage, Credential } from './types';

export const css = `
  .about-section {
    .credential-icon {
      background: var(--c-accent-0);
    }

    .about-image-wrapper {
      aspect-ratio: 0.83;
    }

    .about-image-wrapper::before {
      content: '';
      position: absolute;
      top: -1.5rem;
      left: -1.5rem;
      width: 100%;
      height: 100%;
      background: linear-gradient(135deg, var(--c-primary-2), var(--c-accent-2));
      border-radius: 1rem;
      z-index: 0;
    }
  }
`;

function ImagePlaceholder({ dimensions }: { dimensions: { width: number; height: number } }) {
  return (
    <div class="about-image-placeholder bg-gray-100 relative grow rounded-2xl flex flex-col items-center justify-center text-5xl text-gray-400">
      <span>{dimensions.width}</span>
      <span>×</span>
      <span>{dimensions.height}</span>
    </div>
  );
}

function Credential({ data }: { data: Credential }) {
  return (
    <div class="credential-card bg-gray-100/75 rounded-md flex gap-6 items-center px-4 py-3">
      <div class="credential-icon rounded-full p-2">{data.icon}</div>
      <p class="credential-text">{data.text}</p>
    </div>
  );
}

function AboutImageSection({ image }: { image: AboutImage }) {
  return (
    <div class="about-image-wrapper relative flex">
      {image.type === 'placeholder' ? (
        <ImagePlaceholder dimensions={image.dimensions!} />
      ) : (
        <img src={image.src} alt={image.alt} class="w-full h-full object-cover" loading="lazy" />
      )}
    </div>
  );
}

export function View({ data }: { data: AboutContent }) {
  return (
    <section id="about" class="about-section py-24">
      <div class="max-w-7xl mx-auto px-8">
        <div class="grid md:grid-cols-2 gap-20 items-center">
          <AboutImageSection image={data.image} />

          <div class="about-content flex flex-col gap-6">
            <h2 class="feature-title">{data.title}</h2>

            {data.paragraphs.map((paragraph, index) => (
              <p key={index} class="about-paragraph">
                {paragraph}
              </p>
            ))}

            <div class="credentials-grid flex flex-col md:flex-row gap-4 text-base">
              {data.credentials.map((credential) => (
                <Credential key={credential.id} data={credential} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
